import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorGuiasList } from "./multiselectorguias";

export interface paramsDescargaZE {
    IdGuiasYaIncluidas: number[];
    IdVehiculoZE: number;
}

export interface Props extends kea.ModalProps<number[], boolean, paramsDescargaZE> {
}

/**
* Modal de edición para un DescargaZEGuiasEdit
*/
export class DescargaZEGuiasEdit extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    idVehiculoZE = (props: Props) => props.params.IdVehiculoZE;
    getField = formfields(() => this.props);

    items = createSelectorRx(this.idVehiculoZE, idVehiculoZE => observeResource(resources.CargaZE.GuiasEnVehiculo, idVehiculoZE, new Date()));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    onChange = async (x: number[]) => {
        this.props.onChange(x);
    }

    render() {
        const value = this.props.value;
        const idGuiasYaIncluidas = this.props.params.IdGuiasYaIncluidas;
        const idVehiculoZE = this.props.params.IdVehiculoZE;
        const getField = this.getField;
        const items = this.items(this.props);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Incluir guías"
            >
                <kea.Title titulo={"Seleccionar guías"} >
                </kea.Title>
                <MultiselectorGuiasList value={value} idGuiasYaIncluidas={idGuiasYaIncluidas} onChange={this.onChange} items={items} hideBusqueda />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/multiselector/edit.tsx